"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

var _Input = require("../Input");

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const getWidth = {
  small: "200",
  medium: "324",
  large: "500"
};

const StyledDiv = _styledComponents2.default.div.withConfig({
  displayName: "InputWithLabel__StyledDiv",
  componentId: "sc-11u816h-0"
})(["", " display:flex;flex-direction:column;width:", "px;"], _styles.defaultBody, props => getWidth[props.size]);

const StyledLabel = _styledComponents2.default.label.withConfig({
  displayName: "InputWithLabel__StyledLabel",
  componentId: "sc-11u816h-1"
})(["margin-bottom:8px;display:flex;justify-content:space-between;font-size:12px;font-weight:500;line-height:15px;span{display:", ";color:", ";line-height:14px;font-weight:400;}"], props => props.error ? null : "none", _styles.colors.red);

const generateHTMLId = word =>
// Prevents an error if the user doesn't provide a labelTitle
// A warning will be provided via the `isRequired` prop type, this is just to ensure the page doesn't break
word && word.toLowerCase().split(" ").join("-");

/**
 * Input component specifically for text and password form inputs.
 */
const InputWithLabel = (_ref) => {
  let {
    type = "text",
    size = "small",
    error = null
  } = _ref,
      props = _objectWithoutProperties(_ref, ["type", "size", "error"]);

  return _react2.default.createElement(
    StyledDiv,
    _extends({ size: size }, props),
    _react2.default.createElement(
      StyledLabel,
      _extends({
        htmlFor: generateHTMLId(props.labelTitle),
        error: error
      }, props),
      props.labelTitle,
      _react2.default.createElement(
        "span",
        null,
        error
      )
    ),
    _react2.default.createElement(_Input2.default, _extends({
      id: generateHTMLId(props.labelTitle),
      type: type,
      size: size,
      error: error
    }, props))
  );
};

InputWithLabel.propTypes = {
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(["text", "password"]),
  size: _propTypes2.default.oneOf(["small", "medium", "large"]),
  error: _propTypes2.default.string,
  /**
   * If a labelTitle is not necessary, consider using the [Input](#input) instead
   */
  labelTitle: _propTypes2.default.string.isRequired
};

exports.default = InputWithLabel;